import { ArdoqId } from '@ardoq/api-types';
import {
  getLabelsInterfaceWithModelInterfaces,
  LabelsInterface,
} from '../labelsInterface/labelsInterface';

let backBoneModelInterface: LabelsInterface | undefined;
const getLabelsInterface = () => {
  if (!backBoneModelInterface) {
    backBoneModelInterface = getLabelsInterfaceWithModelInterfaces();
  }
  return backBoneModelInterface;
};

/**
 * To provide scope data interface to this function while keeping the scope progressive,
 * we constuct and cache the LabelsInterface from the model interfaces, using it if
 * the argument wasn't provided.
 */
const getComponentLabelParts = (
  componentId: ArdoqId,
  labelsInterface?: Pick<
    LabelsInterface,
    | 'getComponentDisplayName'
    | 'getComponentTypeName'
    | 'getFieldByName'
    | 'getComponentFieldValue'
    | 'getFieldLabel'
    | 'formatField'
    | 'getComponentLabelFilter'
  >
) => {
  const {
    getComponentDisplayName,
    getComponentTypeName,
    getFieldByName,
    getComponentFieldValue,
    getFieldLabel,
    formatField,
    getComponentLabelFilter,
  } = labelsInterface ?? getLabelsInterface();

  const filter = getComponentLabelFilter();
  const componentFormatting = filter?.value ?? 'name';

  const componentName = getComponentDisplayName(componentId);
  if (componentFormatting === 'name') {
    return {
      label: componentName,
      fieldLabel: null,
      fieldValue: null,
    };
  }

  if (componentFormatting === 'none') {
    return { label: null, fieldLabel: null, fieldValue: null };
  }
  if (componentFormatting === 'type') {
    return {
      label: getComponentTypeName(componentId),
      fieldLabel: null,
      fieldValue: null,
    };
  }
  const field = getFieldByName(componentFormatting, {
    includeTemplateFields: false,
  });
  if (!field) {
    return {
      label: componentName,
      fieldLabel: null,
      fieldValue: null,
    };
  }
  const fieldValue = getComponentFieldValue(componentId, componentFormatting);

  const excludeTime = !filter?.includeTime;

  const formattedFieldValue =
    formatField({
      fieldId: field._id,
      value: fieldValue,
      fieldType: field.type,
      excludeTime,
      textAreaFormat: 'text',
    }) ?? (fieldValue ? `${fieldValue}` : null);
  return {
    label: componentName,
    fieldLabel: getFieldLabel(field._id),
    fieldValue: formattedFieldValue,
  };
};

export { getComponentLabelParts };
